import React from 'react';
import load from 'load-script';

class TeamTailor extends React.Component {
  componentWillMount() {
    load('https://scripts.teamtailor-cdn.com/widgets/production/jobs.js');
  }

  render() {
    return (
      <div
        className="teamtailor-jobs-widget"
        data-teamtailor-limit="30"
        data-teamtailor-popup="true"
        data-teamtailor-department-select="true"
        data-teamtailor-location-select="true"
        data-teamtailor-feed="internal,public"
        data-teamtailor-api-key="__HK1fm3RI6WY8tEvnvuHYydIfzqc3FsUNZykBEJ"
      >
      </div>
    );
  }
}

export default TeamTailor;
